module.exports = __webpack_public_path__ + "img/lv20.12e8b3d2.png";